export const messages = {
  en: {
    devServiceProvide: {
      prevStep: 'Previous',
      nextStep: 'Next',
      finish: 'Finish',
      stepTitles: ['Select Service', 'Develop Service', 'Remark Info']
    },
    viewServiceInfo: {
      title: 'Service Info',
      selectService: 'Select Service',
      addService: 'Add Service',
      serviceId: 'Service ID',
      name: 'Service Name',
      serviceCode: 'Service Code',
      messageQueue: 'Message Queue',
      isInstance: 'Is Instance',
      url: 'URL',
      method: 'Method',
      timeout: 'Timeout',
      retryCount: 'Retry Count'
    },
    addService: {
      title: 'Add Service',
      name: 'Service Name',
      serviceCode: 'Service Code',
      url: 'URL',
      method: 'Method',
      timeout: 'Timeout',
      retryCount: 'Retry Count',
      save: 'Save',
      cancel: 'Cancel',
      required: 'Required'
    },
    chooseService: {
      title: 'Choose Service',
      search: 'Search',
      name: 'Service Name',
      serviceCode: 'Service Code',
      method: 'Method',
      operation: 'Operation',
      select: 'Select'
    },
    devServiceProvideView: {
      title: 'Develop Service',
      implMethod: 'Implementation Method',
      params: 'Parameters',
      sql: 'SQL',
      template: 'Output Template',
      proc: 'Procedure',
      javaScript: 'JavaScript',
      required: 'Required',
      optional: 'Optional'
    },
    serviceProvideRemarkView: {
      title: 'Service Provide Remark',
      description: 'Description',
      optional: 'Optional'
    }
  },
  zh: {
    devServiceProvide: {
      prevStep: '上一步',
      nextStep: '下一步',
      finish: '完成',
      stepTitles: ['选择服务', '开发服务实现', '备注信息']
    },
    viewServiceInfo: {
      title: '服务信息',
      selectService: '选择服务',
      addService: '添加服务',
      serviceId: '服务ID',
      name: '服务名称',
      serviceCode: '服务编码',
      messageQueue: '消息队列',
      isInstance: '是否实例',
      url: '调用地址',
      method: '调用方式',
      timeout: '超时时间',
      retryCount: '重试次数'
    },
    addService: {
      title: '添加服务',
      name: '服务名称',
      serviceCode: '服务编码',
      url: '调用地址',
      method: '调用方式',
      timeout: '超时时间',
      retryCount: '重试次数',
      save: '保存',
      cancel: '取消',
      required: '必填'
    },
    chooseService: {
      title: '选择服务',
      search: '查询',
      name: '服务名称',
      serviceCode: '服务编码',
      method: '调用方式',
      operation: '操作',
      select: '选择'
    },
    devServiceProvideView: {
      title: '开发服务',
      implMethod: '实现方式',
      params: '参数',
      sql: 'SQL',
      template: '输出模板',
      proc: '存储过程',
      javaScript: 'JavaScript',
      required: '必填',
      optional: '选填'
    },
    serviceProvideRemarkView: {
      title: '开发服务提供',
      description: '描述',
optional: '选填'
    }
  },
  'zh-TW': {
    devServiceProvide: {
      prevStep: '上一步',
      nextStep: '下一步',
      finish: '完成',
      stepTitles: ['選擇服務', '開發服務實現', '備註信息']
    },
    viewServiceInfo: {
      title: '服務信息',
      selectService: '選擇服務',
      addService: '添加服務',
      serviceId: '服務ID',
      name: '服務名稱',
      serviceCode: '服務編碼',
      messageQueue: '消息隊列',
      isInstance: '是否實例',
      url: '調用地址',
      method: '調用方式',
      timeout: '超時時間',
      retryCount: '重試次數'
    },
    addService: {
      title: '添加服務',
      name: '服務名稱',
      serviceCode: '服務編碼',
      url: '調用地址',
      method: '調用方式',
      timeout: '超時時間',
      retryCount: '重試次數',
      save: '保存',
      cancel: '取消',
      required: '必填'
    },
    chooseService: {
      title: '選擇服務',
      search: '查詢',
      name: '服務名稱',
      serviceCode: '服務編碼',
      method: '調用方式',
      operation: '操作',
      select: '選擇'
    },
    devServiceProvideView: {
      title: '開發服務',
      implMethod: '實現方式',
      params: '參數',
      sql: 'SQL',
      template: '輸出模板',
      proc: '存儲過程',
      javaScript: 'JavaScript',
      required: '必填',
      optional: '選填'
    },
    serviceProvideRemarkView: {
      title: '開發服務提供',
      description: '描述',
      optional: '選填'
    }
  }
}